import usePluginEntities from "hooks/usePluginEntities";
export const useParameterTypes = () => usePluginEntities("parameterDataTypes");
export const useParameterType = (parameterType) => {
  var _a;
  const _parameterType = (_a = parameterType === "any" ? "value-parameter-v1" : parameterType) != null ? _a : "value-parameter-v1";
  return useParameterTypes().find(({ type }) => type === _parameterType);
};
